import React from 'react';
import { Link } from 'react-router-dom';

const JoinSuccessPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="max-w-md w-full text-center p-8 bg-white shadow-lg rounded-lg">
        <svg
          className="w-16 h-16 mx-auto text-green-500 mb-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h1 className="text-3xl font-serif text-[#232347] mb-2">
          Welcome!
        </h1>
        <p className="text-gray-600 mb-6">
          You are now a member. Thank you for joining the Lotus Healing Spa community. You can now enjoy all the exclusive benefits.
        </p>
        <div className="mt-8">
          <Link
            to="/"
            className="px-8 py-3 rounded-md text-white font-semibold bg-[#B2D8C5] hover:bg-[#88bfa3] transition-colors"
          >
            Go to Homepage
          </Link>
        </div>
        <div className="mt-4">
          <Link
            to="/profile" // Assuming a profile page exists
            className="text-sm text-[#3A5E63] hover:underline"
          >
            View My Profile
          </Link>
        </div>
      </div>
    </div>
  );
};

export default JoinSuccessPage;
